import { useEffect, useRef } from 'react';

function getElementFromErrors(errors) {
  if (!errors) {
    return;
  }

  const firstErrorKey = Object.keys(errors)[0];
  const firstError = errors[firstErrorKey];
  if (!firstError || firstError.length === 0) {
    return;
  }

  if (typeof firstError[0] === 'string') {
    return document.getElementById(firstErrorKey);
  }
  // handle scroll to error for collections
  for (const key of firstError.keys()) {
    if (!firstError[key]) {
      continue;
    }

    const firstCollectionErrorKey = Object.keys(firstError[key])[0];

    return (
      document.getElementById(
        `${firstErrorKey}.${key}.${firstCollectionErrorKey}`
      ) || document.getElementById(`${firstErrorKey}.${key}`)
    );
  }
}

export default function useScrollToError(
  submitCount,
  isValid,
  isValidating,
  isSubmitting,
  errors
) {
  const previousSubmitCountRef = useRef(submitCount);

  return useEffect(() => {
    if (
      isValid ||
      isValidating ||
      previousSubmitCountRef.current === submitCount
    ) {
      return;
    }

    previousSubmitCountRef.current = submitCount;

    const element = getElementFromErrors(errors);

    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }, [submitCount, isValid, isValidating, isSubmitting, errors]);
}
